export enum WfhStatus {
    Pending = 'Pending',
    Approved = 'Approved',
    Rejected = 'Rejected',
}
